export default __webpack_public_path__ + "static/youtube-image-006b05ad71add0dfadba00417987b077.jpg";